import Vue from 'vue';

export default Vue.filter('titleCase', (value) => {
  return value ? `${value.charAt(0).toUpperCase()}${value.slice(1)}` : '';
});
